import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 4,
			width: 22,
			height: 16,
			rx: 2
		}), /* @__PURE__ */ _jsx("path", { d: "M2 9h20m-6 6h3" })]
	})
});
export default SvgPaymentinline;
